export default function Content({ children }) {
  return (
    <main className='relative' tabIndex={0}>
      {children}
    </main>
  )
}
